import React, { useState, useEffect } from 'react';
import { Popover, Typography, Box, Grid, Avatar, Badge } from '@mui/material';
import styles from "./notification.module.css";
import { useSelector } from "react-redux";
import CloseIcon from '@mui/icons-material/Close';
import { ReactComponent as Notification } from "../../utils/assets/notification.svg";
import useAxiosPrivate from "../../utils/hooks/useAxiosPrivate";
import moment from "moment";
import RealTimeNotificationModal from "./realTimeNotification"

export default function NotificationModal({ setOpenAuthentication, setOpenedAccount }) {
    const axios = useAxiosPrivate()
    const role = useSelector((state) => state.auth.role);
    const isUser = role === 'USER';
    const [open, setOpen] = useState(false);
    const [dot, setDot] = useState(false);
    const [notificationData, setNotificationData] = useState([]);
    const [matchNotificationData, setMatchNotificationData] = useState([]);
    const [newNotificationData, setNewNotificationData] = useState([]);
    const [readNotificationData, setReadNotificationData] = useState([]);
    const profilePic = useSelector((state) => state.auth.url);

    const handleClick = (event) => {
        setOpen(true)
        if (matchNotificationData?.length !== notificationData?.length) {
            setDot(false)
            setMatchNotificationData(notificationData)
            setNewNotificationData(notificationData)
        }
        const newNotifi = notificationData.filter(function (o1) {
            // filter out (!) items in result2
            return !matchNotificationData.some(function (o2) {
                return o1.id === o2.id;          // assumes unique id
            });
        })
        const read = notificationData.filter(function (o1) {
            // filter out (!) items in result2
            return matchNotificationData.some(function (o2) {
                return o1.id === o2.id;          // assumes unique id
            });
        })
        setNewNotificationData(newNotifi)
        setReadNotificationData(read)
    }

    const handleClose = () => {
        setOpen(false)
    };

    useEffect(() => {
        loadNotificationData();
        // eslint-disable-next-line
    }, []);

    const loadNotificationData = async (e) => {
        try {
            const { data } = await axios.get("/notifications/list");
            if (matchNotificationData?.length !== data.data?.length) {
                setDot(true)
            }
            setNotificationData(data.data)
        } catch (error) {
            console.log(error);
        }
    };

    const handleVerify = async (e) => {
        try {
            await axios.get(`/actions/complete/${e?.data?.request_id}`);
            await axios.get(`/notifications/mark_as_seen/${e.id}`);
            setOpenAuthentication(true)
        } catch (error) {
            console.log(error);
        }
        setOpen(false)
    };

    const handleReview = async (e) => {
        try {
            await axios.get(`/notifications/mark_as_seen/${e.id}`);
            setOpenedAccount(true)
            loadNotificationData()
        } catch (error) {
            console.log(error);
        }
        setOpen(false)
    };

    const handleMarkAsSeen = async (e) => {
        try {
            await axios.get(`/notifications/mark_as_seen/${e.id}`);
            const { data } = await axios.get("/notifications/list");
            setOpen(false)
            setNotificationData(data.data)
        } catch (error) {
            console.log(error);
        }
    };

    const id = open ? 'simple-popover' : undefined;

    return (
        <div>
            <Box style={{ margin: "0rem 1.5rem 0rem 1.5rem" }} >
                {dot ?
                    <Badge sx={{
                        "& .MuiBadge-badge": {
                            backgroundColor: '#56E4D7'
                        }
                    }} variant="dot">
                        <Notification
                            aria-describedby={id}
                            onClick={handleClick}
                            className={open ? `${styles.navIcon} ${styles.navIconActive}` : styles.navIcon}
                        />
                    </Badge> :
                    <Badge>
                        <Notification
                            aria-describedby={id}
                            onClick={handleClick}
                            className={open ? `${styles.navIcon} ${styles.navIconActive}` : styles.navIcon}
                        />
                    </Badge>
                }
            </Box>
            <Popover
                id={id}
                open={open}
                onClose={handleClose}
                anchorReference="anchorPosition"
                anchorPosition={{ top: 54, left: window.innerWidth }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                marginThreshold={0}
            >
                <Box className={isUser ? `${styles.boxCSS} ${styles.boxCSSNoTitleSeparator}` : styles.boxCSS}>
                    <Box className={isUser ? styles.boxCSS2 : `${styles.boxCSS2} ${styles.boxCSS2Left}`}>
                        <Typography sx={{ fontFamily: "Poppins", fontStyle: "normal", fontWeight: "600", fontSize: "16px", color: "#000000" }} className={styles.notificationHeader}>{isUser ? 'Notification' : `Notification: ${newNotificationData?.length} new`}</Typography>
                    </Box>
                    {newNotificationData.map((item) => (
                        <Box key={item.id} className={styles.boxCSSUnRead}>
                            <Grid container>
                                <Grid item md={10}>
                                    <Grid item md={12}>
                                        <Typography sx={{ p: 1, fontFamily: "Poppins", fontStyle: "normal", fontWeight: "400", fontSize: "10px", color: "#000000" }} className={styles.notificationDate}>{moment(item?.time).format('h:mm a MMM D, YYYY')}</Typography>
                                    </Grid>
                                    <Grid item md={12}>
                                        <Grid container>
                                            <Grid item md={2} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <Avatar
                                                    alt="Remy Sharp"
                                                    src={profilePic}
                                                    sx={{ width: 35, height: 35 }}
                                                />
                                            </Grid>
                                            <Grid item md={10}>
                                                {role === "COACH" ?
                                                    <Typography sx={{ p: 2, fontFamily: "Poppins", fontStyle: "normal", fontWeight: "400", fontSize: "13.5px", color: "#000000" }}>{item?.message}  <span style={{ color: "#0F9BB0", textDecorationLine: 'underline', cursor: "pointer" }} onClick={() => handleVerify(item)}>{item?.data?.status !== 'DECLINED' ? "Verify Now" : null}</span></Typography>
                                                    : <Typography sx={{ p: 2, fontFamily: "Poppins", fontStyle: "normal", fontWeight: "400", fontSize: "13.5px", color: "#000000" }}>{item?.message}  <span style={{ color: "#0F9BB0", textDecorationLine: 'underline', cursor: "pointer" }} onClick={() => handleReview(item)}>Review</span></Typography>
                                                }
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item md={2} style={{ display: "flex", justifyContent: "center", alignItems: isUser ? "flex-start" : "center" }}>
                                    <CloseIcon style={{ cursor: "pointer", fontSize: "10px" }} onClick={() => handleMarkAsSeen(item)} />
                                </Grid>
                            </Grid>
                        </Box>
                    ))}
                    {readNotificationData.map((item) => (
                        <Box key={item.id} className={styles.boxCSSRead}>
                            <Grid container>
                                <Grid item md={10}>
                                    <Grid item md={12}>
                                        <Typography sx={{ p: 1, fontFamily: "Poppins", fontStyle: "normal", fontWeight: "400", fontSize: "10px", color: "#000000" }} className={styles.notificationDate}>{moment(item?.time).format('h:mm a MMM D, YYYY')}</Typography>
                                    </Grid>
                                    <Grid item md={12}>
                                        <Grid container>
                                            <Grid item md={2} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <Avatar
                                                    alt="Remy Sharp"
                                                    src={profilePic}
                                                    sx={{ width: 35, height: 35 }}
                                                />
                                            </Grid>
                                            <Grid item md={10}>
                                                {role === "COACH" ?
                                                    <Typography sx={{ p: 2, fontFamily: "Poppins", fontStyle: "normal", fontWeight: "400", fontSize: "13.5px", color: "#000000" }}>{item?.message}  <span style={{ color: "#0F9BB0", textDecorationLine: 'underline', cursor: "pointer" }} onClick={() => handleVerify(item)}>{item?.data?.status !== 'DECLINED' ? "Verify Now" : null}</span></Typography>
                                                    : <Typography sx={{ p: 2, fontFamily: "Poppins", fontStyle: "normal", fontWeight: "400", fontSize: "13.5px", color: "#000000" }}>{item?.message}  <span style={{ color: "#0F9BB0", textDecorationLine: 'underline', cursor: "pointer" }} onClick={() => handleReview(item)}>Review</span></Typography>
                                                }
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item md={2} style={{ display: "flex", justifyContent: "center", alignItems: isUser ? "flex-start" : "center" }}>
                                    <CloseIcon style={{ cursor: "pointer", fontSize: "10px" }} onClick={() => handleMarkAsSeen(item)} />
                                </Grid>
                            </Grid>
                        </Box>
                    ))}
                </Box>
            </Popover>
            <RealTimeNotificationModal setOpenAuthentication={setOpenAuthentication} setOpenedAccount={setOpenedAccount} setNotificationData={setNotificationData} setDot={setDot} notificationData={notificationData} />
        </div>
    );
}